import appConfig from '@/../appConfig.js';
import {api, appLocalStorage } from '@/app/shared/services';

import * as moment from "moment/moment";

class AppCommons {
  /**
   * @constructor AppCommons
   */
  constructor() {
    /** Initializing the configuration of appCommons */
    this.initAppCommons();
  }

  initAppCommons() {
    this.fetchScopeMeta();
  };

  fetchScopeMeta() {
    const url = "mock-data/scope.json";

    // return api.post(url, payload);
    return api.get(url)
      .then(data => {
        this.scopeMeta = this.filterAndSortTags(data.data);
      })
      .catch(error => {
        throw new Error(error);
      });
  }



  filterAndSortTags(data) {
    let filteredTags = data.filter(t => this.scopeFilter(t));

    return filteredTags.sort(function(t1, t2) {
      var tA = t1.tag.toUpperCase();
      var tB = t2.tag.toUpperCase();
      if (tA < tB) {
        return -1;
      }
      if (tA > tB) {
        return 1;
      }

      // tags must be equal
      return 0;
    });
  }

  userScope() {
    let userInfo = JSON.parse(appLocalStorage.getItem('userInfo'));

    if(userInfo && userInfo.config && userInfo.config.allowed && userInfo.config.allowed.store) {
      return userInfo.config.allowed.store;
    } else {
      return [];
    }
  }

  currentScope() {
    let appScope = JSON.parse(appLocalStorage.getItem('app.scope'));
    let userScope = this.userScope();

    let currentScope = [];

    if(appScope && appScope.store && appScope.store.length > 0) {
      for(var tag of appScope.store) {
        if(userScope && userScope.includes(tag.code)) {
          currentScope.push(tag.code);
        }
      }
    } else {
      currentScope = userScope;
    }

    return currentScope;
  }

  currentScopeTags() {
    let appScope = JSON.parse(appLocalStorage.getItem('app.scope'));
    let userScope = this.userScope();

    let scopeTags = [];

    if(appScope && appScope.store && appScope.store.length > 0) {
      for(var tag of appScope.store) {
        if(userScope && userScope.includes(tag.code)) {
          scopeTags.push(tag);
        }
      }
    } 
    // else {
    //   for(var tag of this.scopeMeta) {
    //     if(userScope && userScope.includes(tag.code)) {
    //       scopeTags.push(tag);
    //     }
    //   }
    // }

    return scopeTags;
  }

  currentScopeTagsTemp() {
    let appScope = JSON.parse(appLocalStorage.getItem('app.scope'));
    let userScope = this.userScope();

    let scopeTags = [];

    if(appScope && appScope.store && appScope.store.length > 0) {
      for(var tag of appScope.store) {
        if(userScope && userScope.includes(tag.code)) {
          scopeTags.push(tag);
        }
      }
    } 
    else {
      for(var tag of this.scopeMeta) {
        if(userScope && userScope.includes(tag.code)) {
          scopeTags.push(tag);
        }
      }
    }

    return scopeTags;
  }

  scopeLocale() {
    let appScope = JSON.parse(appLocalStorage.getItem('app.scope'));
    let userScope = this.userScope();

    let localeToUse = appConfig.config.locale;

    if(appScope && appScope.store && appScope.store.length > 0) {
      for(var tag of appScope.store) {
        if(userScope && userScope.includes(tag.code)) {
          localeToUse = tag.locale ? tag.locale : appConfig.config.locale;
        }
      }
    }

    return localeToUse;
  }

  allowedScope(userInfo, store) {
  
    let allowedScope = [];
  
    if(store && store.length > 0) {
      for(var tag of store) {
        if(userInfo && userInfo.config && userInfo.config.allowed && userInfo.config.allowed.store && 
          userInfo.config.allowed.store.includes(tag.code)) {
          allowedScope.push(tag);
        }
      }
    }
    
    return allowedScope;
  }

  allowedDateScope(startDate, noOfDays, operator, minDate, maxDate, offsetDays) {
    let offsetDaysFromConfig = appConfig.config.offsetDays | 1;
    if(offsetDays >= 0) {
      offsetDaysFromConfig = offsetDays;
    }

    let appScope = JSON.parse(appLocalStorage.getItem('app.scope'));
    let refDate = new Date();

    if(appScope && appScope.date && appScope.date.endDate) {
      refDate = new Date(appScope.date.endDate);
    }

    let current_datetime = startDate ? moment(startDate).subtract(offsetDaysFromConfig, 'days'): moment(refDate).subtract(offsetDaysFromConfig, 'days');
    let now = operator === 'plus' ? moment(refDate).add(noOfDays >=0 ? noOfDays : 90, 'days') : moment(refDate).subtract(noOfDays >=0 ? noOfDays : 90, 'days');
    
    let formatted_current_date = current_datetime.format('M/D/YYYY');
    let formatted_default_min_date = now.format('M/D/YYYY');

    let minDt = minDate ? moment(minDate).format('M/D/YYYY') : moment(new Date("01/01/2017")).format('M/D/YYYY');
    let maxDt = maxDate ? moment(maxDate).format('M/D/YYYY') : formatted_current_date;

    let startDt = operator === 'plus' ? formatted_current_date : formatted_default_min_date;
    let endDt = operator === 'plus' ? formatted_default_min_date : formatted_current_date;

    if(this.guide && !this.guide.allowDate) {
      
    }

    let dateScope = {
      minDate: minDt,
      maxDate: maxDt,
      startDate: startDt,
      endDate: endDt
    }

    // console.log("dateScope", dateScope);

    return dateScope;
  }

  scopeFilter(refTag) {
    // objArray.find(o => o.name === obj.name);
    if(refTag.type === 'S'){
      return this.userScope().includes(refTag.code);
    } else {
      return true;
    }
  }
  
  countOfUnitsBetweenDates(unit, start, end, isExact, format) {
    const sDate = moment(start, format ? format : "MM/DD/YYYY").startOf('isoWeek');
    const eDate = moment(end, format ? format : "MM/DD/YYYY").endOf('isoWeek');

    return isExact ? eDate.diff(sDate, unit, true) : Math.ceil(eDate.diff(sDate, unit, true));
  }

  formatDate(date, formatIn, formatOut) {
    const formattedDate = moment(date, formatIn).format(formatOut)
    // const formattedDate = moment(date, format ? format : "MM/DD/YYYY").startOf('isoWeek');

    return formattedDate;
  }

}

/** Creating the instance of appCommons */
const appCommons = new AppCommons();

export { appCommons };